import React, { useEffect, useState } from 'react';
import { Star, Loader2 } from 'lucide-react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';

/**
 * Los botones «¿en qué ficha de Google?» del diálogo de pedir reseña
 * (2026-08-25; V2, 28/9/2026).
 *
 * Los centros ya no están escritos aquí: salen de GET /api/recordatorios/
 * resenas, que devuelve solo los que tienen enlace de reseñas en
 * Configuración, con su nombre. Sin ninguno, el diálogo lo dice y no ofrece
 * nada que vaya a fallar. `prefijo` mantiene los data-testid de cada
 * pantalla («resena-cjo», «recordatorio-resena-cjo»…).
 */
const COLORES = {
  cjo: 'bg-[#284264] hover:bg-[#1b2c44]',
  instituto: 'bg-[#12724A] hover:bg-[#0A2C1F]',
};

export default function CentrosResena({ onElegir, prefijo = 'resena' }) {
  const [centros, setCentros] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/api/recordatorios/resenas')
      .then(({ data }) => { if (vivo) setCentros(Array.isArray(data) ? data : []); })
      .catch(() => { if (vivo) setCentros([]); });
    return () => { vivo = false; };
  }, []);

  if (centros === null) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground py-2">
        <Loader2 className="w-4 h-4 animate-spin" /> Cargando…
      </div>
    );
  }
  if (centros.length === 0) {
    return (
      <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-3"
        data-testid={`${prefijo}-sin-centros`}>
        No hay ninguna ficha de Google configurada. Dirección puede poner el nombre
        y el enlace de reseñas de cada centro en Configuración.
      </p>
    );
  }
  return (
    <div className="grid gap-2">
      {centros.map((c) => (
        <Button
          key={c.clave}
          type="button"
          className={`${COLORES[c.clave] || COLORES.cjo} justify-start`}
          onClick={() => onElegir(c.clave)}
          data-testid={`${prefijo}-${c.clave}`}
        >
          <Star className="w-4 h-4 mr-2" /> {c.nombre}
        </Button>
      ))}
    </div>
  );
}
